import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';

export const ImageCornerButton = styled(IconButton, {
    shouldForwardProp: (prop) => prop !== 'corner'
})<{ corner: 'left' | 'right' }>(({ theme, corner }) => ({
    position: 'absolute',
    top: '12px',
    left: corner === 'left' ? '8px' : undefined,
    right: corner === 'right' ? '8px' : undefined,
    zIndex: 2,
    padding: 0,
    color: '#fff',
    filter: 'drop-shadow(0 1px 2px rgba(0, 0, 0, 0.6))',
    transition: 'color 0.15s ease',
    '&:hover': {
        color: theme.palette.primary.main,
        backgroundColor: 'transparent'
    },
    '& .MuiSvgIcon-root': {
        fontSize: '30px'
    }
}));
